import gsap from 'gsap'

const OverviewListBlock = {
  el: {
    block: document.querySelector<HTMLElement>('.overview-list-block'),
  },

  init() {
    const el = gsap.utils.selector(this.el.block)
    const items = this.el.block.querySelectorAll('.list-item')

    if (items) {
      gsap.fromTo(
        items,
        {
          opacity: 0,
          x: -10,
        },
        {
          duration: 0.3,
          ease: 'power3.out',
          opacity: 1,
          x: 0,
          stagger: 0.2,
          scrollTrigger: {
            start: '0 87%',
            toggleActions: 'play none resume reverse',
            trigger: items,
          },
        }
      )
    }

    gsap.to(el('[data-id=back]'), {
      scale: 1.1,
      transformOrigin: '50% 50%',
      duration: 2,
      ease: 'power3.out',
    })

    gsap.to(el('[data-id=hand]'), {
      rotation: -6,
      yoyo: true,
      repeat: -1,
      repeatDelay: 0.5,
      duration: 0.8,
      ease: 'power2.inOut',
      transformOrigin: '100% 100%',
    })
  },
}

export default OverviewListBlock
